import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "../../../../../components/NavBarAdmin";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loading-icons";
import { Grid, EstadoCellRenderer } from "../../../../Layout/Grid/GridView";
import Request from "../../../../../api/Requests";

const EventsTransactionsList = () => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();
    const [state, setState] = useState({
        tickets: [],
        event: {
            id: 0,
            name: "",
            id_venues: "",
        },
        modalFormTableReservation: {
            show: false,
            data: {
                table: {},
            },
        },
        modalFormTableReservationInfo: {
            show: false,
            data: {
                table: {},
            },
        },
    });

    useEffect(() => {
        document.title = "Event Tickets | Nightspot Dashboard";
        getEventTicketsTransactionList();
    }, []);

    const getEventTicketsTransactionList = async (closeFormTableReservation = false) => {
        setIsLoading(true);
        let info = await Request('admin/event-list-tickets-transactions', 'GET', { id_events: params.id_events }, true)
        if (info && info.status) {
            setState(info.data);
        }
        setIsLoading(false);
    };


    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#333" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    Loading...
                </div>
            </div>
        );
    };

    const DetailsColumn = (props) => {
        const { data } = props;
        const { transaction_date, client_name, owner_email, client_phone_country, client_phone_number, owner_vat_number, transaction_price_ticket, payment_datetime, payment_method, transaction_number, payment_transaction_id, payment_error_mensage, havePayout, payout_date } = data;

        return (
            <div className="text-center">
                <Link to={`/my/admin/venues/${params.id}/events/${params.id_events}/transactions/${data.id}`}>
                    <button className="btn btn-primary">Detalhes</button>
                </Link>
            </div>
        );
    }


    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-sm-12 dashboard-content">
                        {isLoading ? (
                            <InsideLoading />
                        ) : (
                            <>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <Grid
                                            ref={gridRef}
                                            rows={state.transactions}
                                            cols={[
                                                {
                                                    headerName: "Detalhes",
                                                    cellRenderer: DetailsColumn,
                                                },
                                                { hide: true, field: "id" },
                                                { headerName: "Data", field: "transaction_date" },
                                                { headerName: "Cliente", field: "client_name" },
                                                { headerName: "Email", field: "owner_email" },
                                                {
                                                    headerName: "phone", cellRenderer: (params) => {
                                                        return params.data.client_phone_country + " " + params.data.client_phone_number;
                                                    },
                                                },
                                                { headerName: "Contribuinte", field: "owner_vat_number" },
                                                { headerName: "Valor (€)", cellStyle: { textAlign: "right" }, field: "transaction_price_ticket" },
                                                { headerName: "Data Pagamento", field: "payment_datetime" },
                                                {
                                                    headerName: "Estado",
                                                    field: "payment_status",
                                                    cellRenderer: EstadoCellRenderer,
                                                },
                                                {
                                                    headerName: "Método Pagamento",
                                                    field: "payment_method",
                                                    cellRenderer: (params) => {
                                                        return (
                                                            <div className="text-center">
                                                                <img
                                                                    src={`/img/payments/${params.data.payment_method}.png`}
                                                                    className="img-fluid"
                                                                    style={{ height: "25px", width: "auto" }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                },
                                                { field: "transaction_number" },
                                                { field: "payment_datetime" },
                                                { field: "payment_transaction_id" },
                                                { field: "payment_error_mensage" },
                                                { field: "havePayout" },
                                                { field: "payout_date" },

                                            ]}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </NavBar>
        </div>
    );

}

export default EventsTransactionsList;
